import { api, type EstateSearch, type EstateSearchHit, type Job } from "../lib/api";

/**
 * The Documents page's estate search, kept out of the component so it can be exercised against a
 * faked `fetch` without a DOM. The page calls these and only copies the result into its state.
 */

/**
 * Runs one search. An empty result is a result, not an error: the route says which packages it
 * searched. Only a refusal (too short a query) or a server failure comes back as `error`.
 */
export async function runSearch(q: string): Promise<{ result: EstateSearch | null; error: string | null }> {
  try {
    return { result: await api.search(q), error: null };
  } catch (e) {
    return { result: null, error: (e as Error).message };
  }
}

/** Starts a UC1 lookup for the searched tag in the package the result came from. */
export function startLookup(tag: string, hit: EstateSearchHit): Promise<Job> {
  return api.createJob(tag, hit.package);
}
